const ua = navigator.userAgent || navigator.vendor || window.opera;
export const isInstagram = ua.indexOf('Instagram') > -1
export const isFacebook = (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);

// if (document.documentElement.classList) {
//   if (isInstagram) {
//     window.document.body.classList.add('bv--instagram');
//   }
// }
